const _token = 'token';
const _regulator = 'regulator';
const _userName = "username";
const _PSPRole = "psp_role";
const _blacklist = "blacklist";
const _SearchRole = "search_role";
const _DownloadRole = "download_role";
const _DailyReportRole = "daily_report_role";
const _CampaignReportRole = "campaign_report_role"
const _ReportDownloadRole = "report_download_role"
const _DisplayClickId = "display_click_id"
const _EnableLicenseFilter = "enable_license_filter"
const _EnableLicenseFilterRegulators = "enable_license_filter_regulators"

class Storage {
  /**
   * Returns a authorisation token
   *
   * @return {string} token to insert in the reqeust header
   */
  static getToken() {
    return sessionStorage.getItem(_token);
  }

  /**
   * * @param {string} value the token value
   *
   * @save token
   */
  static saveToken(value) {
    return sessionStorage.setItem(_token, value);
  }

  /**
   * * @delete token
   */
  static deleteToken() {
    return sessionStorage.removeItem(_token);
  }

  /**
   * Returns a regulator string
   *
   * @return {regulator} string to send to the back-end
   */
  static getRegulator() {
    return sessionStorage.getItem(_regulator);
  }

  /**
   * * @param {string} value the regulator value
   *
   * @save regulator
   */
  static saveRegulator(value) {
    return sessionStorage.setItem(_regulator, value);
  }

  /**
   * * @delete regulator
   */
  static deleteRegulator() {
    return sessionStorage.removeItem(_regulator);
  }

  /**
   * Returns a username string
   *
   * @return {username} string
   */
  static getUserName() {
    return sessionStorage.getItem(_userName);
  }

  /**
   * * @param {string} value the username
   *
   * @save username
   */
  static saveUserName(value) {
    return sessionStorage.setItem(_userName, value);
  }

  /**
   * * @delete regulator
   */
  static deleteUserName() {
    return sessionStorage.removeItem(_userName);
  }

  /**
  * * @param {string} value the psp_role
  *
  * @save psp_role
  */
  static savePSPRole(value) {
    return sessionStorage.setItem(_PSPRole, value);
  }

  /**
  * Returns a psp_role string
  *
  * @return {psp_role} string
  */
  static getPSPRole() {
    return sessionStorage.getItem(_PSPRole);
  }

  /**
   * * @param {string} value the blacklist
   *
   * @save blacklist
   */
  static saveBlacklist(value) {
    return sessionStorage.setItem(_blacklist, JSON.stringify(value));
  }

  /**
  * Returns a blacklist of pages
  *
  * @return {Array} blacklist
  */
  static getBlacklist() {
    return JSON.stringify(sessionStorage.getItem(_blacklist));
  }

  /**
  * * @param {string} value the search_role
  *
  * @save search_role
  */
  static saveSearchRole(value) {
    return sessionStorage.setItem(_SearchRole, value);
  }

  /**
  * Returns a search_role string
  *
  * @return {search_role} string
  */
  static getSearchRole() {
    return sessionStorage.getItem(_SearchRole);
  }

  /**
  * * @param {string} value the download_role
  *
  * @save download_role
  */
  static saveDownloadRole(value) {
    return sessionStorage.setItem(_DownloadRole, value);
  }

  /**
  * Returns a download_role string
  *
  * @return {download_role} string
  */
  static getDownloadRole() {
    return sessionStorage.getItem(_DownloadRole);
  }

  /**
  * * @param {string} value the daily_report_role
  *
  * @save daily_report_role
  */
  static saveDailyReportRole(value) {
    return sessionStorage.setItem(_DailyReportRole, value);
  }

  /**
  * Returns a daily_report_role string
  *
  * @return {daily_report_role} string
  */
  static getDailyReportRole() {
    return sessionStorage.getItem(_DailyReportRole);
  }

  /**
  * * @param {string} value the campaign_report_role
  *
  * @save campaign_report_role
  */
    static saveCampaignReportRole(value) {
      return sessionStorage.setItem(_CampaignReportRole, value);
    }

    /**
    * Returns a campaign_report_role string
    *
    * @return {string} campaign_report_role
    */
    static getCampaignReportRole() {
      return sessionStorage.getItem(_CampaignReportRole);
    }

    /**
    * * @param {string} value the report_download_role
    *
    * @save report_download_role
    */
    static saveReportDownloadRole(value) {
      return sessionStorage.setItem(_ReportDownloadRole, value);
    }

    /**
    * Returns a report_download_role string
    *
    * @return {report_download_role} string
    */
    static getReportDownloadRole() {
      return sessionStorage.getItem(_ReportDownloadRole);
    }

  /**
  * * @param {string} value the display_click_id
  *
  * @save display_click_id
  */
    static saveDisplayClickID(value) {
      return sessionStorage.setItem(_DisplayClickId, value);
    }

  /**
  * Returns a display_click_id string
  *
  * @return {string} display_click_id
  */
  static getDisplayClickID() {
    return sessionStorage.getItem(_DisplayClickId);
  }

  static saveEnableLicenseFilter(value) {
    return sessionStorage.setItem(_EnableLicenseFilter, value ? '1' : '0');
  }

  static getEnableLicenseFilter(regulator) {
    if (sessionStorage.getItem(_EnableLicenseFilter) !== '1') {
      return false;
    }
    if (regulator === undefined) {
      return true;
    }
    return this.getEnableLicenseFilterRegulators().includes(regulator);
  }

  static saveEnableLicenseFilterRegulators(value) {
    return sessionStorage.setItem(_EnableLicenseFilterRegulators, JSON.stringify(Array.isArray(value) ? value : []));
  }

  static getEnableLicenseFilterRegulators() {
    try {
      const value = JSON.parse(sessionStorage.getItem(_EnableLicenseFilterRegulators));
      return Array.isArray(value) ? value : [];
    } catch (e) {
      return [];
    }
  }
}
export default Storage;
